import { Button, Group, Modal, Text } from "@mantine/core";
import { useLanguage } from "../../stores/LanguageStore";
import { IconFolderUp } from "@tabler/icons-react";
import { useState } from "react";
import { useDisclosure } from "@mantine/hooks";
import FolderSelector from "../Selectors/FolderSelector";
import BackButton from "../View/BackButton";
import PoolSelector from "../Selectors/PoolSelector";

const SelectionMover = ({
  handleEdit,
  getEditFunction,
  ids,
  apiRef,
  onFinish,
  setTableLoading,
  folderType,
  isPool,
  isRowAction,
  closeMenu,
  rows,
}) => {
  const lang = useLanguage((s) => s.language);
  const [opened, { open, close }] = useDisclosure();
  const [loading, setLoading] = useState(false);
  const [folder, setFolder] = useState(null);

  const main = () => {
    let requests = [];
    let data = ids || apiRef?.current?.getSelectedRows();

    data.forEach((id) => {
      requests.push(
        new Promise((resolve, reject) => {
          let current = rows?.find((x) => x.id === id);
          let editFunction = handleEdit || getEditFunction?.(current);

          editFunction({
            id: current?.id || id?.id || id,
            folder_id: isPool ? undefined : folder?.id || 0,
            pools_ids: isPool
              ? [...(current?.pools?.map((x) => x.id) || []), folder.id]
              : undefined,
          }).then((res) => {
            // if (apiRef && !disableDelete) {
            //   document
            //     .querySelectorAll(`[data-id='${row.id}']`)
            //     .forEach((el) => {
            //       el.style.animation = `forwards 1.5s deletedAnim ease`;
            //     });
            //   setTimeout(() => {
            //     apiRef.current.updateRows([
            //       { id: row.id, _action: "delete" },
            //       { id: `#${row.id}`, _action: "delete" },
            //     ]);
            //   }, 750);
            // }
            // notifications.show({
            //   message: "1 élément déplacé",
            // });
            onFinish?.();
            resolve();
          });
        })
      );
    });

    setLoading(true);
    Promise.all(requests).finally(() => {
      if (apiRef) {
        apiRef.current.setRowSelectionModel([]);
      }
      setTableLoading?.(true);
      setLoading(false);
      close();
      closeMenu?.();
    });
  };

  return (
    <>
      {isRowAction ? (
        <Button
          variant="subtle"
          color="primary"
          onClick={open}
          leftSection={<IconFolderUp size={18} />}
          justify="start"
        >
          {lang.components.folder_navigator.mover.row_action_label}{" "}
          {isPool ? "pool" : lang.contact_lists.folder}
        </Button>
      ) : (
        <Button
          variant="light"
          color="primary"
          disabled={ids.length === 0}
          onClick={open}
          leftSection={<IconFolderUp size={18} />}
          justify="start"
          className="to-blue"
        >
          {lang.components.folder_navigator.mover.tooltip}{" "}
          {isPool ? "pool" : lang.contact_lists.folder}
        </Button>
      )}

      <Modal
        opened={opened}
        onClose={close}
        title={
          <Text size="md" truncate="end">
            {lang.components.folder_navigator.mover.text1}{" "}
            <b>
              {" "}
              {ids.length} {lang.components.folder_navigator.mover.elements}{" "}
            </b>
            {
              lang.components.folder_navigator.mover[
                isPool ? "text2_pool" : "text2"
              ]
            }
          </Text>
        }
        centered
        styles={{
          title: {
            maxWidth: "92%",
          },
        }}
      >
        {isRowAction ? (
          <Text size="sm" mb={"sm"}>
            {lang.components.folder_navigator.mover.row_action_text}{" "}
            {isPool ? "pool" : lang.contact_lists.folder}
          </Text>
        ) : (
          <Text size="sm" mb={"sm"}>
            {lang.components.folder_navigator.mover.text3}{" "}
            {isPool ? "pool" : lang.contact_lists.folder}
          </Text>
        )}

        {isPool ? (
          <PoolSelector
            type={folderType}
            value={folder}
            setValue={setFolder}
            required
            withinPortal={true}
          />
        ) : (
          <FolderSelector
            type={folderType}
            value={folder}
            setValue={setFolder}
            required
            withinPortal={true}
          />
        )}

        <Group justify="end" mt={"md"}>
          <BackButton onClick={close} />
          <Button color="primary" onClick={main} loading={loading}>
            {lang.components.folder_navigator.move.move}
          </Button>
        </Group>
      </Modal>
    </>
  );
};

export default SelectionMover;
